import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";
import {LiveCasinoGridItemInfobarDefaultBox} from "./live-casino-grid-item-infobar.default.box";

export const LiveCasinoGridItemInfobarCasino777Box = styled(LiveCasinoGridItemInfobarDefaultBox)`
   background: ${props => hexToRgba(props.theme.components.newLiveCasino.colors.gridItem.infobarBackground, 0.92)};
   &::before {
      background: transparent linear-gradient(90deg, transparent 0%, ${props => props.theme.colors.buttonLight} 33%, ${props => props.theme.colors.buttonLight} 69%, transparent 100%) 0% 0% no-repeat padding-box;
   }
`;
